import { connect } from 'react-redux';
import ConfigurationView from './ConfigurationView';
import NM_TEMPLATES from '../../../../mocks/NMTemplateConfig';
import isEmpty from 'lodash/isEmpty';
const mapStateToProps = (state, ownProps) => {
  const { paging } = state;

  return {
    paging,
    nmTemplates: isEmpty(NM_TEMPLATES) ? {} : NM_TEMPLATES,
    vendorEndpoints: ownProps.vendorEndpoints,
    vendorEndpointParams: ownProps.vendorEndpointParams,
  };
};

export default connect(mapStateToProps)(ConfigurationView);
